module.exports = __webpack_public_path__ + "img/page_bg_smartOA.2673b41d.png";